import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  container: {
    width: '21cm',
    minHeight: '29.7cm',
    height: '29.7cm',
    maxHeight: '29.7cm',
    display: 'block',
    padding: '0 25px',
    margin: '0 auto 0',
    position: 'relative',
  },
}));

const GenerateReportsPage = ({ children }) => {
  const classes = useStyles();

  return <div className={classes.container}>{children}</div>;
};

GenerateReportsPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GenerateReportsPage;
